import { powerStoneColumn } from "../resource/power-stone-column";
import { NeededColumn } from "./needed-column";

export const powerStoneNeededColumn = new NeededColumn(
  "145e4aa5-1ea8-4b89-bca9-9d363d349ff4",
  powerStoneColumn,
  "PS Needed"
)
